import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import withNextStep from '../../components/hoc/withNextStep';
import Step100 from './Step100';

export default compose(
  withRouter,
  withNextStep
)(Step100);
